import React, { useEffect, Component } from "react";
import LayoutOperation from "../../components/layout_operation";
import { Table } from "antd";
import { DatePicker, Select } from "antd";
import ChartAllJob from "../../ui/chart/all_job";
import ChartJobStatus from "../../ui/chart/job_status";
import ChartSLA from "../../ui/chart/sla";
import ChartProcess from "../../ui/chart/process";
import ChartJobCat from "../../ui/chart/job_category";
import ChartJobRemain from "../../ui/chart/job_remain";
import ChartEmployee from "../../ui/chart/employee";
import ChartTeam from "../../ui/chart/team";
import Cookies from "js-cookie";
import Api from "../../services/ServiceApi";
import { Link } from "react-router-dom";

const { Option } = Select;
const { RangePicker } = DatePicker;

const job = [
  {
    sla: 1,
    id: 432411,
    date: "20/09/2019 09.00",
    area: "BKK1",
    type_equipment: "LED",
    date_remaining: 4,
    technician: 3,
    status: "Open",
  },
  {
    sla: 2,
    id: 432412,
    date: "20/09/2019 11.00",
    area: "BKK1",
    type_equipment: "LED",
    date_remaining: 2,
    technician: 5,
    status: "On Process",
  },
  {
    sla: 3,
    id: 432413,
    date: "20/09/2019 13.00",
    area: "BKK2",
    type_equipment: "LED",
    date_remaining: 4,
    technician: 2,
    status: "On Process",
  },
  {
    sla: 4,
    id: 432414,
    date: "20/09/2019 15.00",
    area: "BKK4",
    type_equipment: "LED",
    date_remaining: 3,
    technician: 3,
    status: "On Process",
  },
  {
    sla: 1,
    id: 432415,
    date: "20/09/2019 17.00",
    area: "BKK3",
    type_equipment: "LED",
    date_remaining: 5,
    technician: 1,
    status: "Open",
  },
];
const equipment = [
  {
    id: "R230678",
    type: "Other",
    name: "Adapter Router",
    stock_on_hand: 122,
    min: 23,
    max: 160,
    price: 300,
  },
  {
    id: "R230679",
    type: "Other",
    name: "Adapter Digital",
    stock_on_hand: 353,
    min: 44,
    max: 500,
    price: 190,
  },
  {
    id: "R230680",
    type: "Other",
    name: "Cable Tie",
    stock_on_hand: 150,
    min: 20,
    max: 40,
    price: 121,
  },
  {
    id: "R230681",
    type: "Other",
    name: "Timer Digital",
    stock_on_hand: 110,
    min: 14,
    max: 40,
    price: 55,
  },
  {
    id: "R230682",
    type: "Other",
    name: "Meter",
    stock_on_hand: 80,
    min: 17,
    max: 50,
    price: 32,
  },
];
const columns_job = [
  {
    title: "SLA",
    dataIndex: "sla",
    key: "sla",
    render: (item) => (
      <div>
        {item === 1 ? <span className="dot-urgent"></span> : null}
        {item === 2 ? <span className="dot-high"></span> : null}
        {item === 3 ? <span className="dot-normal"></span> : null}
        {item === 4 ? <span className="dot-low"></span> : null}
      </div>
    ),
  },
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "Date/Time",
    dataIndex: "date",
    key: "date",
  },
  {
    title: "Area",
    dataIndex: "area",
    key: "area",
  },
  {
    title: "Type Equipment",
    dataIndex: "type_equipment",
    key: "type_equipment",
  },
  {
    title: "Date Remaining",
    dataIndex: "date_remaining",
    key: "date_remaining",
    render: (item) => <span>{item} Day</span>,
  },
  {
    title: "Technician",
    dataIndex: "technician",
    key: "technician",
    render: (item) => <span className="font-thai-b c-blue">{item}</span>,
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (item) => (
      <div>
        {item === "Open" ? (
          <span className="font-thai-b c-blue">{item}</span>
        ) : (
          <span className="font-thai-b c-yellow">{item}</span>
        )}
      </div>
    ),
  },
];
class Dashboard extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      data_dashbord: [],
      columns_equipment: [
        {
          title: "Material ID",
          dataIndex: "material_id",
          key: "material_id",
        },
        {
          title: "Material Name",
          dataIndex: "material_name",
          key: "material_name",
        },
        {
          title: "Name",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "Unit Code",
          dataIndex: "unit_code",
          key: "unit_code",
        },
        // {
        //   title: "Min",
        //   dataIndex: "min",
        //   key: "min",
        // },
        // {
        //   title: "Max",
        //   dataIndex: "max",
        //   key: "max",
        // },
        // {
        //   title: "Price",
        //   dataIndex: "price",
        //   key: "price",
        //   render: (item) => <span className="font-thai-b c-blue">{item}</span>,
        // },
      ],
    };
  }

  async componentDidMount() {
    const get_detail = await Api.post("get_dashboard_data", {
      company_id: "1",
      operator_id: Cookies.get("operator_id"),
      project_id: "1",
      dates: "2020-11-17",
    });
    this.setState({
      data_dashbord: get_detail.data.data,
    });
    console.log(get_detail.data.data);
  }

  render() {
    return (
      <LayoutOperation active={0}>
        <div className="wrapper-header d-flex" style={{ height: "284px" }}>
          <div className="container-fluid">
            <div className="row align-items-center mt-3">
              <div className="col-3">
                <img
                  src={Api.absoluteUrl("/icon/dashboard_white.svg")}
                  className="mr-3"
                  alt=""
                />
                <h2 className="c-white text-uppercase m-0 d-inline-block font-mont-b fs-20">
                  Dashboard
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="wrapper-body" style={{ marginTop: "-210px" }}>
          <div className="container-fluid">
            <div className="card-dashboard mb-4">
              <ul className="navTwo mb-0">
                <li>
                  <div>
                    <span className="font-thai-sb fs-18 mr-2 c-blue">Date</span>
                    <RangePicker />
                  </div>
                </li>
                <li>
                  <span className="font-thai-sb fs-18 mr-2 c-blue">Area</span>
                  <Select
                    placeholder="Please select"
                    optionFilterProp="children"
                    className="font-mont-r fs-12"
                  >
                    <Option value="">All</Option>
                    <Option value="bkk1">BKK1</Option>
                    <Option value="bkk2">BKK2</Option>
                    <Option value="bkk3">BKK3</Option>
                  </Select>
                </li>
              </ul>
            </div>
            <div className="row mb-4">
              <div className="col-9">
                <div className="row mb-4">
                  <div className="col-4">
                    <div className="card-dashboard">
                      <h3
                        className="font-mont-sb fs-16 c-blue"
                        style={{ marginBottom: "40px" }}
                      >
                        ALL Job
                      </h3>
                      <div style={{ margin: "-20px -20px 0 -20px" }}>
                        <ChartAllJob
                          data={
                            this.state.data_dashbord.result_job_total_job ===
                            undefined
                              ? []
                              : this.state.data_dashbord.result_job_total_job
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="card-dashboard">
                      <h3
                        className="font-mont-sb fs-16 c-blue"
                        style={{ marginBottom: "40px" }}
                      >
                        Job Status
                      </h3>
                      <div style={{ margin: "-20px -20px 0 -20px" }}>
                        <ChartJobStatus
                          data={
                            this.state.data_dashbord.result_job_status ===
                            undefined
                              ? []
                              : this.state.data_dashbord.result_job_status
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="card-dashboard">
                      <h3
                        className="font-mont-sb fs-16 c-blue"
                        style={{ marginBottom: "40px" }}
                      >
                        SLA Performance
                      </h3>
                      <div style={{ margin: "-20px -20px 0 -20px" }}>
                        <ChartSLA />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-dashboard">
                  <h3 className="font-mont-sb fs-16 c-blue">
                    Remaining of Job
                  </h3>
                  <div>
                    <ChartJobRemain
                      data={
                        this.state.data_dashbord.result_job_not_finish ===
                        undefined
                          ? []
                          : this.state.data_dashbord.result_job_not_finish
                      }
                    />
                  </div>
                  <h3 className="font-mont-sb fs-16 c-blue">Job Category</h3>
                  <div>
                    <ChartJobCat
                      data={
                        this.state.data_dashbord.result_job_category ===
                        undefined
                          ? []
                          : this.state.data_dashbord.result_job_category
                      }
                    />
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3 className="font-mont-sb fs-16 c-blue m-0">
                      20 September 2019
                    </h3>
                    <Link to="/ma_list" className="btn btn-warning">
                      View All Job
                    </Link>
                  </div>
                  <Table
                    rowKey="id"
                    columns={this.columns_job}
                    dataSource={this.job}
                    pagination={false}
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="wrapper-dashboard-right">
                  <div className="head">
                    <div style={{ padding: "0 20px" }}>
                      <h5 className="font-mont-m fs-14 c-white mb-3">
                        Monitoring
                      </h5>
                      {/* <ul>
                                            <li>
                                                <DatePicker style={{ width: "120px" }} onChange={() => this.onChange()} />
                                            </li>
                                            <li>
                                                <Select
                                                    placeholder="ทุกภูมิภาค"
                                                >
                                                    <Option value="jack">Jack</Option>
                                                </Select>
                                            </li>
                                        </ul> */}
                    </div>

                    <div className="row">
                      <div className="col text-center">
                        <h4 className="font-mont-sb fs-26 c-white m-0">60</h4>
                        <span className="font-mont-m fs-14 c-white">
                          Job All Process
                        </span>
                      </div>
                      <div
                        className="col text-center"
                        style={{
                          borderLeft: "1px solid rgba(255, 255, 255, 0.25)",
                        }}
                      >
                        <h4 className="font-mont-sb fs-26 c-white m-0">22</h4>
                        <span className="font-mont-m fs-14 c-white">
                          Employee
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="body">
                    <div className="mb-4">
                      <ChartEmployee
                        data={
                          this.state.data_dashbord.result_emp === undefined
                            ? []
                            : this.state.data_dashbord.result_emp
                        }
                      />
                    </div>
                    <div className="mb-4">
                      <ChartTeam
                        data={
                          this.state.data_dashbord.result_team === undefined
                            ? []
                            : this.state.data_dashbord.result_team
                        }
                      />
                    </div>
                    <h5 className="font-mont-sb fs-12 c-blue mb-3">
                      Process Status
                    </h5>
                    <div>
                      <ChartProcess />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-9">
                <div className="card-dashboard">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3 className="font-mont-sb fs-16 c-blue m-0">
                      Top 5 Material
                    </h3>
                  </div>
                  <Table
                    rowKey="id"
                    columns={this.state.columns_equipment}
                    dataSource={
                      this.state.data_dashbord.result_top_five_mat_usage ===
                      undefined
                        ? []
                        : this.state.data_dashbord.result_top_five_mat_usage
                    }
                    pagination={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutOperation>
    );
  }
}

export default Dashboard;
